import React from 'react';
import type { SegmentDefinitionSummary } from '../segment-definitions-api';
import { getSegmentUsageTags, type SegmentUsageMap } from './segment-usage';
import styles from './SegmentPicker.module.css';

interface BlockedSegments {
  segmentIds: string[];
  tag: string;
}

const NO_BLOCKED_SEGMENTS: BlockedSegments = { segmentIds: [], tag: '' };

interface SegmentOptionListProps {
  segments: SegmentDefinitionSummary[];
  selectedIds: string[];
  onSelect: (canonicalVersionId: string) => void;
  usedElsewhere: SegmentUsageMap;
  variant?: 'include' | 'exclude';
  blocked?: BlockedSegments;
}

export const SegmentOptionList: React.FC<SegmentOptionListProps> = ({
  segments,
  selectedIds,
  onSelect,
  usedElsewhere,
  variant = 'include',
  blocked = NO_BLOCKED_SEGMENTS,
}) => (
  <ul className={styles.optionList} data-variant={variant}>
    {segments.map(({ id, name, description, canonicalVersionId }) => {
      const isSelected = selectedIds.includes(canonicalVersionId);
      const isBlocked = blocked.segmentIds.includes(canonicalVersionId);
      const tags = isBlocked
        ? [blocked.tag]
        : getSegmentUsageTags(usedElsewhere.get(canonicalVersionId));
      return (
        <li key={id}>
          <button
            type="button"
            data-selected={isSelected || undefined}
            aria-pressed={isSelected}
            disabled={isBlocked}
            onClick={() => onSelect(canonicalVersionId)}>
            <strong>
              {name}
              {tags.map(tag => (
                <small key={tag}>{tag}</small>
              ))}
            </strong>
            {description && <span>{description}</span>}
          </button>
        </li>
      );
    })}
  </ul>
);
